export default "__VITE_ASSET__CODYrHUh__"